'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var PropTypes = _interopRequireWildcard(_propTypes);

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

var _themeProvider = require('@spp/theme-provider');

var _irisPropTypes = require('@spp/iris-prop-types');

var _uiCarousel = require('@spp/ui-carousel');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GalleryThemedCarousel = (0, _themeProvider.themer)('@spp/ui-gallery:carousel')(_uiCarousel.ThemedCarousel);

var Gallery = function (_Component) {
    (0, _inherits3.default)(Gallery, _Component);

    function Gallery() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, Gallery);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Gallery.__proto__ || (0, _getPrototypeOf2.default)(Gallery)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            currentSlide: 0
        }, _this.onKeyUp = function (e) {
            switch (e.key) {
                case 'ArrowLeft':
                    _this.changeSlide(-1);
                    break;
                case 'ArrowRight':
                    _this.changeSlide(1);
                    break;
                default:
            }
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(Gallery, [{
        key: 'getComponent',
        value: function getComponent(slide) {
            var components = this.props.components;

            return components[slide] || {};
        }
    }, {
        key: 'getCaption',
        value: function getCaption(slide) {
            var component = this.getComponent(slide);
            var type = component.type;


            if (type === 'image') {
                var _component$caption = component.caption;
                _component$caption = _component$caption === undefined ? {} : _component$caption;
                var value = _component$caption.value;


                return value;
            } else if (type === 'video') {
                var _component$descriptio = component.description;
                _component$descriptio = _component$descriptio === undefined ? {} : _component$descriptio;
                var _value = _component$descriptio.value;


                return _value;
            }

            return undefined;
        }
    }, {
        key: 'getByline',
        value: function getByline(slide) {
            var component = this.getComponent(slide);
            var type = component.type;


            if (type === 'image') {
                var _component$byline = component.byline;
                _component$byline = _component$byline === undefined ? {} : _component$byline;
                var title = _component$byline.title;

                return title;
            }

            return undefined;
        }
    }, {
        key: 'getStateString',
        value: function getStateString() {
            return this.props.stateString.replace('{currentSlide}', this.state.currentSlide + 1).replace('{totalSlides}', this.props.components.length);
        }
    }, {
        key: 'canBeInfinite',
        value: function canBeInfinite() {
            var components = this.props.components;


            return components[0].type !== 'video' && components[components.length - 1].type !== 'video';
        }
    }, {
        key: 'changeSlide',
        value: function changeSlide(direction) {
            var _this2 = this;

            var totalSlides = this.props.components.length;

            this.setState(function (_ref2) {
                var currentSlide = _ref2.currentSlide;

                var nextSlide = (0, _uiCarousel.inRange)(currentSlide + direction, {
                    max: totalSlides,
                    infinite: _this2.canBeInfinite()
                });

                return currentSlide !== nextSlide ? { currentSlide: nextSlide } : null;
            });
        }
    }, {
        key: 'isOnVideoSlide',
        value: function isOnVideoSlide() {
            return this.props.components[this.state.currentSlide].type === 'video';
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _props = this.props,
                children = _props.children,
                components = _props.components,
                theme = _props.theme;
            var currentSlide = this.state.currentSlide;


            return (
                // eslint-disable-next-line jsx-a11y/no-static-element-interactions
                _react2.default.createElement(
                    'div',
                    {
                        className: theme.root,
                        tabIndex: 0,
                        onKeyUp: this.onKeyUp,
                        'data-test-tag': '@spp/ui-gallery'
                    },
                    _react2.default.createElement(
                        GalleryThemedCarousel,
                        {
                            totalSlides: components.length,
                            currentSlide: currentSlide,
                            onSlideChange: function onSlideChange(slide) {
                                _this3.setState({ currentSlide: slide });
                            },
                            infinite: this.canBeInfinite()
                        },
                        _react2.default.createElement(
                            'div',
                            {
                                className: (0, _classnames3.default)(theme.carousel, (0, _defineProperty3.default)({}, theme.videoSlide, this.isOnVideoSlide()))
                            },
                            _react2.default.createElement(
                                _uiCarousel.ChangeSlideButton,
                                { type: 'previous', className: theme.button + ' ' + theme.buttonPrevious },
                                _react2.default.createElement('span', { className: theme.buttonContent })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: theme.slides },
                                _react2.default.createElement(
                                    _uiCarousel.SlideContainer,
                                    null,
                                    children
                                )
                            ),
                            _react2.default.createElement(
                                _uiCarousel.ChangeSlideButton,
                                { type: 'next', className: theme.button + ' ' + theme.buttonNext },
                                _react2.default.createElement('span', { className: theme.buttonContent })
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: theme.statusBar },
                        _react2.default.createElement(
                            'span',
                            { className: theme.state },
                            this.getStateString()
                        ),
                        _react2.default.createElement(
                            'span',
                            { className: theme.caption },
                            this.getCaption(currentSlide)
                        ),
                        _react2.default.createElement(
                            'span',
                            { className: theme.byline },
                            this.getByline(currentSlide)
                        )
                    )
                )
            );
        }
    }]);
    return Gallery;
}(_react.Component);

Gallery.propTypes = {
    children: PropTypes.node.isRequired,
    components: PropTypes.arrayOf(_irisPropTypes.components.component).isRequired,
    theme: PropTypes.shape({
        root: PropTypes.string,
        carousel: PropTypes.string,
        videoSlide: PropTypes.string,
        button: PropTypes.string,
        buttonPrevious: PropTypes.string,
        buttonContent: PropTypes.string,
        slides: PropTypes.string,
        buttonNext: PropTypes.string,
        statusBar: PropTypes.string,
        state: PropTypes.string,
        caption: PropTypes.string,
        byline: PropTypes.string
    }),
    stateString: PropTypes.string
};
Gallery.defaultProps = {
    theme: {},
    stateString: '{currentSlide} av {totalSlides}'
};
exports.default = Gallery;
//# sourceMappingURL=Gallery.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-gallery/lib/cjs/Gallery.js
 ** module id = 654
 ** module chunks = 1
 **/